import { render, staticRenderFns } from "./Profesiones.vue?vue&type=template&id=2d65ae42"
import script from "./Profesiones.vue?vue&type=script&lang=js"
export * from "./Profesiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports